var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"active_title"},[_vm._t("icon",function(){return [_c('span',{staticClass:"default_icon"})]}),_c('div',{staticClass:"text"},[_vm._t("default",function(){return [_vm._v("标题内容")]}),_vm._t("custom")],2),_vm._t("cont")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }